import { useLocation, useParams } from "react-router-dom";
import Axios from "../../../utils/axios";
import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import ButtonsCrud from "../../../components/Catalogs/ButtonsCrud";
import '../../../assets/css/AddCatalogs.css';
import GoBack from "../../../components/Moleculas/GoBack";
import Input from "../../../components/Atomos/Inputs/Input";
import CatalogTitle from "../../../components/Moleculas/Catalog Text/CatalogTitle";
import CatalogSubTitle from "../../../components/Moleculas/Catalog Text/CatalogSubTitle";
import { getCurrentTimestamp, updateData } from "../../../utils/functions";
interface DataItem {
  id?: string;
  name?: string;
  createdDate?: number;
}
interface iCatalogProps {
  mode: "add" | "edit";
}
interface IErrorState {
  nameRequired: boolean,
  nameDuplicated: boolean,
  nameErrorMessage?: string,
  nameDuplicatedMessage?: string
}

const initialErrorState: IErrorState = {
  nameRequired: false,
  nameDuplicated: false,
  nameErrorMessage: "",
  nameDuplicatedMessage: '',
};

const AddDegree: React.FC<iCatalogProps> = (props) => {
  const { state } = useLocation();
  const location = useLocation()
  const axios = new Axios();
  const navigate = useNavigate();
  const { id } = useParams();
  const { mode } = props;
  const [buttonClicked, setButtonClicked] = useState('saveButton');
  const [errorState, setErrorState] = useState<IErrorState>(initialErrorState);
  const [currentName, setCurrentName] = useState(state?.name ?? '')

  useEffect(() => {
    if (mode === 'edit' && state) {
      setCurrentName(state.name)
      setButtonClicked('updateButton')
    }
  }, [mode, state]);

  const handleDelete = async (id: string) => {
    const response = await axios.Delete(`/Degree`, id);
    if (response.status === 200) {
      navigate(-1)
    } else {
      console.error('Error al eliminar el elemento:', response.data);
    }
  }

  const handleButtonClick = (buttonName: string) => {
    setButtonClicked(buttonName);
    handleSubmit()
  };

  const handleSubmit = () => {

    const errors = {
      ...initialErrorState,
      nameRequired: currentName.trim() === '',
      nameErrorMessage: currentName.trim() === '' ? 'Name is required' : ''
    }
    setErrorState(errors)

    const isValid = Object.values(errors).every((error) => !error);
    if (!isValid) {
      return
    } else {
      if (buttonClicked === 'updateButton') {
        handleUpdate();
      } else if (buttonClicked === 'saveButton') {
        handleSave();
      }
    }
  };

  const handleSave = async () => {
    try {
      const addData: DataItem = {
        name: currentName,
        createdDate: getCurrentTimestamp()
      };
      const response = await axios.Post("/Degree", addData);
      if (response.data.error) {
        const errors = {
          ...initialErrorState,
          nameDuplicated: true
        }
        setErrorState(errors)
        const isValid = Object.values(errors).every((error) => !error)
        if (!isValid) {
          const newError = {
            ...initialErrorState,
            nameDuplicated: true,
            nameDuplicatedMessage: 'This value is already registered in the DB. Please input a different/new one.'
          }
          setErrorState(newError)
        }
        return
      }
      if (response.status === 200) {
        setTimeout(() => {
          navigate(-1)
        }, 500);
      }
    } catch (error: any) {
      console.error('Error creating element:', error);
    }
  };

  const handleUpdate = async () => {
    if (state.id) {
      const updatedData: DataItem = {
        id: state.id,
        name: currentName,
      };
      try {
        const response = await axios.Put("Degree", updatedData);
        if (response && response.data.error) {
          const errors = {
            ...errorState,
            nameDuplicated: true,
            nameDuplicatedMessage: 'This value is already registered in the DB. Please input a different/new one.'
          }
          setErrorState(errors)
          const isValid = Object.values(errors).every((error) => !error)
          if (!isValid) {
            return
          }
        }
        if (state.name !== currentName) {
          await updateData('Education', 'schoolName', state.name, currentName);
        }
        navigate(-1);
      } catch (error: any) {
        console.error("Error al actualizar el elemento:", error);
      }
    }
  };

  const inputOnchange = (e: any) => {
    setCurrentName(e.target.value)
    setErrorState(initialErrorState)
  }

  return (
    <>
        <CatalogTitle
          title={`${props.mode === 'add' ? 'New Degree' : `Edit ${state?.name}`}`} className="text-Default">
          <GoBack />
        </CatalogTitle>
        <article className='articleSection'>
          <section className="formsectionNTitle">
            <CatalogSubTitle className="text-accent-Default-dark" title="Degree Information" />
            <Input onChange={inputOnchange} title="Name" name="Name" value={currentName} required error={errorState.nameRequired} errorMsj={errorState.nameErrorMessage} />
            {errorState.nameDuplicated &&
              <span className={`flex flex-wrap items-center text-sm font-medium text-feedback-error`}>
                {errorState.nameDuplicatedMessage}
              </span>
            }
          </section>
          <ButtonsCrud
            Catalog="Degree"
            mode={props.mode}
            id={id ? id : ""}
            disabled={errorState.nameRequired || errorState.nameDuplicated}
            actionButton={handleButtonClick}
            onDelete={handleDelete}
            state={state}
            newState={{...state, name:currentName}}
          />
        </article>
    </>
  );
}
export default AddDegree;